<div
  class="phone-field"
  [class.open]="countryPickerOpen()"
  [class.error]="numberValue.invalid && numberValue.dirty"
>
  <input
    payee-input
    class="number-control"
    data-testid="phone-number"
    [formControl]="numberValue"
  />
  <div class="country-picker">
    <button
      type="button"
      class="country-trigger"
      [disabled]="isDisabled"
      (click)="toggleCountryPicker($event)"
    >
      <span class="area-flag">{{ areaCode.value ?? "HU" | countryFlag }}</span>
      <span class="toggle-arrows">
        <mat-icon>unfold_more</mat-icon>
      </span>
      <span class="area-code">+{{ getCountryCallingCode(areaCode.value ?? "HU") }}</span>
    </button>

    @if (countryPickerOpen()) {
      <div
        class="country-panel"
        role="listbox"
        (click)="$event.stopPropagation()"
      >
        <input
          #countrySearchInput
          class="country-search"
          type="search"
          [value]="countrySearch"
          [placeholder]="countrySearchPlaceholder"
          (input)="onCountrySearchInput(countrySearchInput.value)"
        />
        <div class="country-options">
          @for (option of countries; track option) {
            <button
              type="button"
              role="option"
              class="country-option"
              [class.selected]="areaCode.value === option"
              [attr.aria-selected]="areaCode.value === option"
              (click)="selectCountry(option)"
            >
              {{ option | countryFlag }}&nbsp; +{{ getCountryCallingCode(option) }}&nbsp; {{ getCountryDisplayName(option) }}
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
@if (numberValue.hasError("phoneNumber") && numberValue.dirty) {
  <span
    class="phone-error"
    payee-error
  >
    {{
      "ERROR_MESSAGES.INVALID_FORMAT_WITH_EXAMPLE"
        | translate
          : {
              pattern: numberValue.getError("phoneNumber"),
            }
    }}
  </span>
}
